import { render, staticRenderFns } from "./DropUp.component.vue?vue&type=template&id=c8796d5a&scoped=true&lang=pug"
import script from "./DropUp.component.vue?vue&type=script&lang=ts"
export * from "./DropUp.component.vue?vue&type=script&lang=ts"
import style0 from "./DropUp.component.vue?vue&type=style&index=0&id=c8796d5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8796d5a",
  null
  
)

export default component.exports